export default __webpack_public_path__ + "static/zaklepschronisko-promo@3x-4ef1dfa55e76aaa993a6da391031c629.jpg";